import styled, { createGlobalStyle } from "styled-components";
import '@fortawesome/fontawesome-free/css/all.min.css';


export const GlobalStyles = createGlobalStyle`

/* Linha abaixo usado pra identificar se algum elemento esta extrapolando as margen */
/* * {
  outline: 1px solid rgba(255, 0, 0, 0.2);
} */
*,
*::before,
*::after {
  box-sizing: border-box;
}

body,
html {
  overflow-x: hidden;
  transform: none !important;
}


  :root {
    /* Variáveis de cores para tema escuro (padrão) */
    --primary-color: #ff6b00;
    --primary-dark: #e05f00;
    --secondary-color: #222222;
    --dark-bg: #1a1a1a;
    --light-bg: #2a2a2a;
    --card-bg: #333333;
    --text-color: #ffffff;
    --text-secondary: #cccccc;
    --light-text: #ffffff;
    --border-color: #444444;
    --input-bg: #2a2a2a;
    --box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
    --gray-light: #555555;
  }
@font-face {
  font-family: 'Gunar Thin';
  src: url('/fonts/gunar-thin-webfont.woff2') format('woff2'),
       url('/fonts/gunar-thin-webfont.woff') format('woff');
  font-weight: normal;
  font-style: normal;
}

  /* Variáveis para tema claro */
  [data-theme="light"] {
    --primary-color: #ff6b00;
    --primary-dark: #e05f00;
    --secondary-color: #333333;
    --dark-bg: #eee;
    --light-bg: #e3e3e3;
    --card-bg: #ffffff;
    --text-color: #333333;
    --text-secondary: #666666;
    --light-text: #ffffff;
    --border-color: #dddddd;
    --input-bg: #fff;
    --box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
    --gray-light: #cccccc;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: 'poppins', sans-serif;
    line-height: 1.6;
    color: var(--text-color);
    background-color: var(--dark-bg);
    transition: all 0.3s ease;
    overflow-x: hidden;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: 700;
    line-height: 1.2;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  img {
    max-width: 100%;
  }

  .container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }

  section {
    padding: 100px 0;
  }

  .highlight {
    color: var(--primary-color);
  }

  /* Animações globais */
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes pulse {
    0% {
      transform: scale(1);
      opacity: 0.3;
    }
    100% {
      transform: scale(1.1);
      opacity: 0.1;
    }
  }

  @keyframes slide {
    0% {
      transform: translateX(-30%);
    }
    100% {
      transform: translateX(30%);
    }
  }

  @keyframes shine {
    0% {
      left: -50%;
      top: -50%;
    }
    100% {
      left: 150%;
      top: 150%;
    }
  }

  @keyframes borderGlow {
    0% {
      box-shadow: 0 0 5px rgba(255, 107, 0, 0.3);
    }
    50% {
      box-shadow: 0 0 20px rgba(255, 107, 0, 0.5);
    }
    100% {
      box-shadow: 0 0 5px rgba(255, 107, 0, 0.3);
    }
  }

  /* Estilos para botões */
  .btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 12px 30px;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    border: none;
    font-size: 1rem;
    text-decoration: none;
    
    &.btn-primary {
      background-color: var(--primary-color);
      color: var(--light-text);
      position: relative;
      overflow: hidden;
      
      &:hover {
        background-color: var(--primary-dark);
        transform: translateY(-3px);
      }
      
      &::after {
        content: '';
        position: absolute;
        top: -50%;
        left: -50%;
        width: 200%;
        height: 200%;
        background: linear-gradient(45deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.1) 50%, rgba(255,255,255,0) 100%);
        transform: rotate(45deg);
        animation: shine 3s infinite;
      }
      
      i {
        margin-right: 10px;
      }
    }
  }
`;

export default GlobalStyles;
